// src/components/LanguageMenu.jsx
import * as React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

const SUPPORTED = [
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" }
];

// Normalise "fr-FR" -> "fr"
function norm(lng) {
  if (!lng) return "en";
  const code = String(lng).toLowerCase();
  if (code.includes("-")) return code.split("-")[0];
  if (code.includes("_")) return code.split("_")[0];
  return code;
}

export default function LanguageMenu({ compact = false, sx }) {
  const { i18n } = useTranslation();
  const [lang, setLang] = React.useState(norm(i18n.language));

  // Synchronise si la langue change ailleurs dans l’app
  React.useEffect(() => {
    const current = norm(i18n.language);
    if (current !== lang) setLang(current);
  }, [i18n.language]);

  const handleChange = async (e) => {
    const next = e.target.value;
    setLang(next);
    // Persiste pour i18next-browser-languagedetector
    localStorage.setItem("i18nextLng", next);
    await i18n.changeLanguage(next);
  };

  return (
    <Box sx={{ minWidth: compact ? 80 : 140, ...sx }}>
      <FormControl size={compact ? "small" : "medium"} fullWidth>
        <Select
          value={lang}
          onChange={handleChange}
          variant={compact ? "outlined" : "standard"}
          sx={{
            borderRadius: 2,
            px: compact ? 1 : 0,
            height: compact ? 36 : undefined,
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              gap: 1
            }
          }}
          renderValue={(value) => {
            const item = SUPPORTED.find((l) => l.code === value);
            return item ? item.label : value?.toUpperCase();
          }}
        >
          {SUPPORTED.map((l) => (
            <MenuItem key={l.code} value={l.code}>
              {l.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
